import { render, staticRenderFns } from "./GetItemFixStoreFixProductPrice.vue?vue&type=template&id=048903a8"
import script from "./GetItemFixStoreFixProductPrice.vue?vue&type=script&lang=js"
export * from "./GetItemFixStoreFixProductPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports